<template>
  <div class="pt-2" style="padding:20%">
    <v-row>
      <v-col cols="12">
        <influencer-data-table :refresh="isRefresh" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import InfluencerDataTable from './DataTable'
export default {
  name: 'cogs-summary',
  components: {
    InfluencerDataTable
  },
  props: [
    'refresh'
  ],
  data() {
    return {
      isRefresh: 1
    }
  },
  methods: {
    reload() {
      this.isRefresh += 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?457b207e